import { ApiProperty } from "@nestjs/swagger";

export class CompanyModel {
    @ApiProperty()
    companyId: number;
    @ApiProperty()
    companyCode: string;
    @ApiProperty()
    companyName: string;
    @ApiProperty()
    address: string;
    @ApiProperty()
    username: string;

    constructor(companyId: number, companyCode: string, companyName: string, address: string,  username: string) {
        this.companyId = companyId;
        this.companyCode = companyCode;
        this.companyName = companyName;
        this.address = address;
        this.username = username;
    }
}
